import {createContext, useState} from "react";

export const TemplateContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    let emptyTemplate = {
        id: "",
        code: "",
        name: "",
        title: "",
        content: "",
        type: "",
        enabled: true,
        description: ""
    }

    const [template, setTemplate] = useState(emptyTemplate);
    const [templates, setTemplates] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [templateDialog, setTemplateDialog] = useState(false);

    const resetTemplate = () => {
        setTemplate(emptyTemplate);
    };

    // Make the context object:
    const templateContext = {
        template,
        resetTemplate,
        setTemplate,
        templates,
        setTemplates,
        submitted,
        setSubmitted,
        templateDialog,
        setTemplateDialog,
    };

    // pass the value in provider and return
    return <TemplateContext.Provider value={templateContext}>{children}</TemplateContext.Provider>;
}

export const {Consumer} = TemplateContext;
